import React from "react";
import ImageButton from "./ImageButton";
import ShareSvg from "./ShareSvg";

class ProductShareButton extends React.Component {
  render() {
    let { isShared } = this.state;
    // console.log(" ShareButton STATE", isShared);

    const imageButtonType = isShared ? "disabled" : "raised";
    return (
      <ImageButton type={imageButtonType} action={this.share}>
        <ShareSvg />
      </ImageButton>
    );
  }

  constructor(props) {
    super(props);

    let isShared = false;

    this.state = { isShared };
  }

  componentDidMount() {}
  componentWillUnmount() {}

  share = async () => {
    try {
      // Check if we're in browser environment
      if (typeof window === "undefined") return;

      // Check if Web Share API is supported and we're not in an iframe
      if (window.navigator.share && !window.frameElement) {
        await window.navigator.share({
          title: this.props.name,
          url: window.location.href,
        });
        this.setState({ isShared: true });
      }
      // Fallback to clipboard
      else if (window.navigator.clipboard) {
        await window.navigator.clipboard.writeText(window.location.href);
        this.setState({ isShared: true });
        if (this.props.toast) {
          this.props.toast();
        }
      }
      // If neither is available
      else {
        // Create a fallback by creating a temporary input element
        const tempInput = document.createElement("input");
        tempInput.value = window.location.href;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        this.setState({ isShared: true });
        if (this.props.toast) {
          this.props.toast();
        }
      }
    } catch (error) {
      // Handle share cancellation or errors gracefully
      console.log("Share failed:", error);
      // Don't show error if user just cancelled the share
      if (error.name !== "AbortError") {
        alert("Could not share at this time. Please try again.");
      }
    }
  };
}

export default ProductShareButton;
